/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function AIAgent({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinejoin="round" d="M12.892 1.063a.094.094 0 0 1 .177 0c.17.485.276.783.448 1.04.152.227.341.427.56.591.248.186.54.307 1.016.503a.102.102 0 0 1 0 .188c-.476.196-.768.317-1.016.503a2.4 2.4 0 0 0-.56.59c-.172.258-.277.556-.448 1.041a.094.094 0 0 1-.177 0c-.17-.485-.275-.783-.447-1.04a2.4 2.4 0 0 0-.56-.591c-.248-.186-.54-.307-1.016-.503a.102.102 0 0 1 0-.188c.475-.196.768-.317 1.015-.502.219-.165.409-.365.56-.592.173-.257.278-.555.448-1.04Z" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="m3.563 8.785 3.7 2.137a2 2 0 0 0 2 0l4.987-2.88a.5.5 0 0 1 .75.434v1.802a.5.5 0 0 1-.25.433l-5.486 3.167a2 2 0 0 1-2 0l-3.701-2.136C2.708 11.298 1 9.932 1 8.02m0 0c0-1.375.848-2.033 1.63-2.303.524-.181 1.086-.011 1.567.267l3.067 1.77a2 2 0 0 0 2 0l1.646-.95M1 8.02c0-1.525 1.04-2.713 1.56-3.116l4.82-2.782a2 2 0 0 1 1.338-.24" /></svg>;
}
;